import { render, staticRenderFns } from "./DescriptionListComponent.vue?vue&type=template&id=51a70a35&scoped=true"
import script from "./DescriptionListComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a70a35",
  null
  
)

export default component.exports